// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"ef2eaaa5","530":"19c2a629","584":"85df5cab","638":"c9feb3a3","744":"435146b8","920":"c753edee","997":"85df5cab"}[chunkId] + ".chunk.css";
};